import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import styles from "./paymentlist.module.css";
import { Check, CreditCard, FileMinus, X } from "react-feather";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useState } from "react";
import { TableLoader } from "../../../../../../../components/LoaderC";
import PaymentCard from "./PaymentCard";
import InfiniteScroll from "react-infinite-scroller";

const PaymentList = ({ contentLoading, data, setPage, page, hasMore, setLoading, setSnackbarOpen, setSnackbarMsg, setAddBillModalShow, setAddCreditModalShow, setAddPaymentModalShow, setIsUpdate, setEditId, setDeleteModalShow, setDeleteId, setDeleteType }) => {
    const [taskExpanded, setTaskExpanded] = useState("");

    const handleChange = (panel) => (event, isTaskExpanded) => {
        setTaskExpanded(isTaskExpanded ? panel : false);
    }

    return (<>
        {contentLoading && (<div className="Loader TableLoader">
            <TableLoader />
        </div>)}
        {!contentLoading && <div className={`${styles.RentRollListSec}`}>
            <div className="FormAccording RentRoll Theme">
                <div className={`${styles.RentRollListHeader}`}>
                    <div className={`${styles.HeaderUnder}`}>
                        <p className={`${styles.Text}`}>Date</p>
                        <p className={`${styles.Text}`}>Description</p>
                        <p className={`${styles.Text} ${styles.Bill}`}>Charged (Bill)</p>
                        <p className={`${styles.Text} ${styles.Payment}`}>Paid (Payment)</p>
                        <p className={`${styles.Text} ${styles.Balance}`}>Running Balance</p>
                    </div>
                </div>

                <InfiniteScroll
                    pageStart={0}
                    initialLoad={false}
                    loadMore={() => {
                        if (hasMore) {
                            setPage((prev) => prev + 1);
                        }
                    }}
                    hasMore={hasMore}
                    threshold={150}
                    loader={<div className={`${styles.CSSLoaderSec}`} key={0}>
                        <span className={`${styles.CSSCuatomLoader}`}></span>
                        <p>Loading...</p>
                    </div>}
                >
                    <div className={`${styles.RentRollMonthGroup}`}>
                        {data?.map((item, index) => {
                            return <PaymentCard key={index} item={item} setLoading={setLoading.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setAddBillModalShow={setAddBillModalShow.bind(this)} setAddCreditModalShow={setAddCreditModalShow.bind(this)} setAddPaymentModalShow={setAddPaymentModalShow.bind(this)} setIsUpdate={setIsUpdate.bind(this)} setEditId={setEditId.bind(this)} setDeleteModalShow={setDeleteModalShow.bind(this)} setDeleteId={setDeleteId.bind(this)} setDeleteType={setDeleteType.bind(this)} />
                        })}
                    </div>
                </InfiniteScroll>

                {/*<div className={`${styles.RentRollMonthGroup}`}>
                    

                    <div className={`${styles.MonthDivider}`}>
                        <span className={`${styles.MonthLabel}`}>April 2026</span>
                        <div className={`${styles.MonthLine}`}></div>
                        <span className={`${styles.MonthSum}`}>Billed $1,250 &nbsp;·&nbsp; Collected $1,250</span>
                    </div>
                    <Accordion expanded={taskExpanded === "panel1"} onChange={handleChange("panel1")}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
                            <div className={`${styles.NotesCard}`}>
                                <div className={`${styles.RentRollDateSec} ${styles.Green}`}>
                                    <div className={`${styles.RentRollDate}`}>Apr 11</div>
                                    <div className={`${styles.RentRollYear}`}>2026</div>
                                </div>
                                <div className={`${styles.RentRollDesc} ${styles.Green}`}>
                                    <div className={`${styles.Top}`}>
                                        <div className={`${styles.Badge}`}><CreditCard /></div>
                                        <div className={`${styles.Title}`}>Remaining balance</div>
                                    </div>
                                    <div className={`${styles.SubText}`}>Payment sent</div>
                                </div>
                                <div className={`${styles.RentRollDue}`}>
                                    <div className={`${styles.DueEmpty}`}>—</div>
                                </div>
                                <div className={`${styles.RentRollPayment}`}>
                                    <div className={`${styles.PaymentOk}`}>
                                        <div className={`${styles.Label}`}><Check /> Collected</div>
                                        <div className={`${styles.Amount}`}>$250.00</div>
                                    </div>
                                </div>
                                <div className={`${styles.RentRollBalance}`}>
                                    <div className={`${styles.BalanceZero}`}>
                                        <div className={`${styles.Label}`}>Cleared</div>
                                        <div className={`${styles.Amount}`}>$0.00</div>
                                    </div>
                                </div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails className={`${styles.CussAccoRow}`}>
                            <div className={`${styles.RentRollExpandSec}`}>
                                <div className={`${styles.DetailsSec}`}>
                                    <div className={`${styles.DetailsGrid}`}>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Payer</div>
                                            <div className={`${styles.Text}`}>Kimora Love</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Memo</div>
                                            <div className={`${styles.Text}`}>Remaining balance</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Amount</div>
                                            <div className={`${styles.Text}`}>$250.00</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Type</div>
                                            <div className={`${styles.Text}`}>One Time</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Status</div>
                                            <div className={`${styles.Text}`}>Completed</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Sent On</div>
                                            <div className={`${styles.Text}`}>Apr 11, 2026</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Method</div>
                                            <div className={`${styles.Text}`}>Cash App Pay</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Deposit Date</div>
                                            <div className={`${styles.Text}`}>Apr 11, 2026</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Account</div>
                                            <div className={`${styles.Text}`}>ZuJiKOOPVA</div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${styles.ButtonSec}`}>
                                    <button className={`${styles.Button} ${styles.Blue}`}>Resend Receipt</button>
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={taskExpanded === "panel2"} onChange={handleChange("panel2")}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
                            <div className={`${styles.NotesCard}`}>
                                <div className={`${styles.RentRollDateSec} ${styles.Red}`}>
                                    <div className={`${styles.RentRollDate}`}>Apr 9</div>
                                    <div className={`${styles.RentRollYear}`}>2026</div>
                                </div>
                                <div className={`${styles.RentRollDesc} ${styles.Red}`}>
                                    <div className={`${styles.Top}`}>
                                        <div className={`${styles.Badge}`}><CreditCard /></div>
                                        <div className={`${styles.Title}`}>Half — payment failed</div>
                                    </div>
                                    <div className={`${styles.SubText}`}>ACH Transfer</div>
                                </div>
                                <div className={`${styles.RentRollDue}`}>
                                    <div className={`${styles.DueEmpty}`}>—</div>
                                </div>
                                <div className={`${styles.RentRollPayment}`}>
                                    <div className={`${styles.PaymentFaild}`}>
                                        <div className={`${styles.Label}`}><X /> Failed</div>
                                        <div className={`${styles.Amount}`}>$1,050.00</div>
                                    </div>
                                </div>
                                <div className={`${styles.RentRollBalance}`}>
                                    <div className={`${styles.BalanceOwnd}`}>
                                        <div className={`${styles.Label}`}>Balance due</div>
                                        <div className={`${styles.Amount}`}>$250.00</div>
                                    </div>
                                </div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails className={`${styles.CussAccoRow}`}>
                            <div className={`${styles.RentRollExpandSec}`}>
                                <div className={`${styles.DetailsSec}`}>
                                    <div className={`${styles.DetailsGrid}`}>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Payer</div>
                                            <div className={`${styles.Text}`}>Kimora Love</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Memo</div>
                                            <div className={`${styles.Text}`}>Half</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Amount</div>
                                            <div className={`${styles.Text}`}>$1,050.00</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Type</div>
                                            <div className={`${styles.Text}`}>One Time</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Status</div>
                                            <div className={`${styles.Text}`}>Failed</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Sent On</div>
                                            <div className={`${styles.Text}`}>Apr 9, 2026</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Method</div>
                                            <div className={`${styles.Text}`}>ACH Transfer</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Deposit Date</div>
                                            <div className={`${styles.Text}`}>—</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Account</div>
                                            <div className={`${styles.Text}`}>—</div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${styles.ButtonSec}`}>
                                    <button className={`${styles.Button} ${styles.BlueTwo}`}>Retry Payment</button>
                                    <button className={`${styles.Button} ${styles.Blue}`}>Resend Receipt</button>
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={taskExpanded === "panel3"} onChange={handleChange("panel3")}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
                            <div className={`${styles.NotesCard}`}>
                                <div className={`${styles.RentRollDateSec} ${styles.Green}`}>
                                    <div className={`${styles.RentRollDate}`}>Apr 9</div>
                                    <div className={`${styles.RentRollYear}`}>2026</div>
                                </div>
                                <div className={`${styles.RentRollDesc} ${styles.Green}`}>
                                    <div className={`${styles.Top}`}>
                                        <div className={`${styles.Badge}`}><CreditCard /></div>
                                        <div className={`${styles.Title}`}>Half</div>
                                    </div>
                                    <div className={`${styles.SubText}`}>Payment sent</div>
                                </div>
                                <div className={`${styles.RentRollDue}`}>
                                    <div className={`${styles.DueEmpty}`}>—</div>
                                </div>
                                <div className={`${styles.RentRollPayment}`}>
                                    <div className={`${styles.PaymentOk}`}>
                                        <div className={`${styles.Label}`}><Check /> Collected</div>
                                        <div className={`${styles.Amount}`}>$1,000.00</div>
                                    </div>
                                </div>
                                <div className={`${styles.RentRollBalance}`}>
                                    <div className={`${styles.BalanceOwnd}`}>
                                        <div className={`${styles.Label}`}>Balance due</div>
                                        <div className={`${styles.Amount}`}>$250.00</div>
                                    </div>
                                </div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails className={`${styles.CussAccoRow}`}>
                            <div className={`${styles.RentRollExpandSec}`}>
                                <div className={`${styles.DetailsSec}`}>
                                    <div className={`${styles.DetailsGrid}`}>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Payer</div>
                                            <div className={`${styles.Text}`}>Kimora Love</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Memo</div>
                                            <div className={`${styles.Text}`}>Half</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Amount</div>
                                            <div className={`${styles.Text}`}>$1,000.00</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Type</div>
                                            <div className={`${styles.Text}`}>One Time</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Status</div>
                                            <div className={`${styles.Text}`}>Completed</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Sent On</div>
                                            <div className={`${styles.Text}`}>Apr 8, 2026</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Method</div>
                                            <div className={`${styles.Text}`}>Cash App Pay</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Deposit Date</div>
                                            <div className={`${styles.Text}`}>Apr 8, 2026</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Account</div>
                                            <div className={`${styles.Text}`}>ZuJiKOOPVA</div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${styles.ButtonSec}`}>
                                    <button className={`${styles.Button} ${styles.Blue}`}>Resend Receipt</button>
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={taskExpanded === "panel4"} onChange={handleChange("panel4")}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
                            <div className={`${styles.NotesCard}`}>
                                <div className={`${styles.RentRollDateSec} ${styles.Yellow}`}>
                                    <div className={`${styles.RentRollDate}`}>Apr 4</div>
                                    <div className={`${styles.RentRollYear}`}>2026</div>
                                </div>
                                <div className={`${styles.RentRollDesc} ${styles.Yellow}`}>
                                    <div className={`${styles.Top}`}>
                                        <div className={`${styles.Badge}`}><FileMinus /></div>
                                        <div className={`${styles.Title}`}>Late Fee for April</div>
                                    </div>
                                    <div className={`${styles.SubText}`}>Bill issued</div>
                                </div>
                                <div className={`${styles.RentRollDue}`}>
                                    <div className={`${styles.Label}`}>Charged</div>
                                    <div className={`${styles.Amount}`}>$50.00</div>
                                </div>
                                <div className={`${styles.RentRollPayment}`}>
                                    <div className={`${styles.DueEmpty}`}>—</div>
                                </div>
                                <div className={`${styles.RentRollBalance}`}>
                                    <div className={`${styles.BalanceOwnd}`}>
                                        <div className={`${styles.Label}`}>Balance due</div>
                                        <div className={`${styles.Amount}`}>$1,250.00</div>
                                    </div>
                                </div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails className={`${styles.CussAccoRow}`}>
                            <div className={`${styles.RentRollExpandSec}`}>
                                <div className={`${styles.DetailsSec}`}>
                                    <div className={`${styles.DetailsGrid}`}>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Invoice No.</div>
                                            <div className={`${styles.Text}`}>102117</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Type</div>
                                            <div className={`${styles.Text}`}>One Time</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Issued On</div>
                                            <div className={`${styles.Text}`}>Apr 4, 2026</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Due Date</div>
                                            <div className={`${styles.Text}`}>Apr 4, 2026</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Notes</div>
                                            <div className={`${styles.Text}`}>Late fee applied for April rent</div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${styles.ButtonSec}`}>
                                    <button className={`${styles.Button} ${styles.Red}`}>Delete</button>
                                    <button className={`${styles.Button} ${styles.Blue}`}>Resend Bill</button>
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={taskExpanded === "panel5"} onChange={handleChange("panel5")}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
                            <div className={`${styles.NotesCard}`}>
                                <div className={`${styles.RentRollDateSec} ${styles.Blue}`}>
                                    <div className={`${styles.RentRollDate}`}>Apr 1</div>
                                    <div className={`${styles.RentRollYear}`}>2026</div>
                                </div>
                                <div className={`${styles.RentRollDesc} ${styles.Blue}`}>
                                    <div className={`${styles.Top}`}>
                                        <div className={`${styles.Badge}`}><FileMinus /></div>
                                        <div className={`${styles.Title}`}>Monthly Rent for April</div>
                                    </div>
                                    <div className={`${styles.SubText}`}>Bill issued</div>
                                </div>
                                <div className={`${styles.RentRollDue}`}>
                                    <div className={`${styles.Label}`}>Charged</div>
                                    <div className={`${styles.Amount}`}>$1,200.00</div>
                                </div>
                                <div className={`${styles.RentRollPayment}`}>
                                    <div className={`${styles.DueEmpty}`}>—</div>
                                </div>
                                <div className={`${styles.RentRollBalance}`}>
                                    <div className={`${styles.BalanceOwnd}`}>
                                        <div className={`${styles.Label}`}>Balance due</div>
                                        <div className={`${styles.Amount}`}>$1,200.00</div>
                                    </div>
                                </div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails className={`${styles.CussAccoRow}`}>
                            <div className={`${styles.RentRollExpandSec}`}>
                                <div className={`${styles.DetailsSec}`}>
                                    <div className={`${styles.DetailsGrid}`}>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Invoice No.</div>
                                            <div className={`${styles.Text}`}>102108</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Type</div>
                                            <div className={`${styles.Text}`}>Monthly</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Issued On</div>
                                            <div className={`${styles.Text}`}>Mar 27, 2026</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Due Date</div>
                                            <div className={`${styles.Text}`}>Apr 1, 2026</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Notes</div>
                                            <div className={`${styles.Text}`}>Monthly rent charge for April 2026</div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${styles.ButtonSec}`}>
                                    <button className={`${styles.Button} ${styles.Red}`}>Delete</button>
                                    <button className={`${styles.Button} ${styles.Blue}`}>Resend Bill</button>
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                </div>
                {/*<div className={`${styles.RentRollMonthGroup}`}>
                    <div className={`${styles.MonthDivider}`}>
                        <span className={`${styles.MonthLabel}`}>March 2026</span>
                        <div className={`${styles.MonthLine}`}></div>
                        <span className={`${styles.MonthSum}`}>Billed $50 &nbsp;·&nbsp; Collected $1,250</span>
                    </div>
                    <Accordion expanded={taskExpanded === "panel6"} onChange={handleChange("panel6")}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
                            <div className={`${styles.NotesCard}`}>
                                <div className={`${styles.RentRollDateSec} ${styles.Green}`}>
                                    <div className={`${styles.RentRollDate}`}>Mar 10</div>
                                    <div className={`${styles.RentRollYear}`}>2026</div>
                                </div>
                                <div className={`${styles.RentRollDesc} ${styles.Green}`}>
                                    <div className={`${styles.Top}`}>
                                        <div className={`${styles.Badge}`}><CreditCard /></div>
                                        <div className={`${styles.Title}`}>Rest of rent</div>
                                    </div>
                                    <div className={`${styles.SubText}`}>Payment sent</div>
                                </div>
                                <div className={`${styles.RentRollDue}`}>
                                    <div className={`${styles.DueEmpty}`}>—</div>
                                </div>
                                <div className={`${styles.RentRollPayment}`}>
                                    <div className={`${styles.PaymentOk}`}>
                                        <div className={`${styles.Label}`}><Check /> Collected</div>
                                        <div className={`${styles.Amount}`}>$250.00</div>
                                    </div>
                                </div>
                                <div className={`${styles.RentRollBalance}`}>
                                    <div className={`${styles.BalanceZero}`}>
                                        <div className={`${styles.Label}`}>Cleared</div>
                                        <div className={`${styles.Amount}`}>$0.00</div>
                                    </div>
                                </div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails className={`${styles.CussAccoRow}`}>
                            <div className={`${styles.RentRollExpandSec}`}>
                                <div className={`${styles.DetailsSec}`}>
                                    <div className={`${styles.DetailsGrid}`}>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Payer</div>
                                            <div className={`${styles.Text}`}>Kimora Love</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Memo</div>
                                            <div className={`${styles.Text}`}>Remaining balance</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Amount</div>
                                            <div className={`${styles.Text}`}>$250.00</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Type</div>
                                            <div className={`${styles.Text}`}>One Time</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Status</div>
                                            <div className={`${styles.Text}`}>Completed</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Sent On</div>
                                            <div className={`${styles.Text}`}>Apr 11, 2026</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Method</div>
                                            <div className={`${styles.Text}`}>Cash App Pay</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Deposit Date</div>
                                            <div className={`${styles.Text}`}>Apr 11, 2026</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Account</div>
                                            <div className={`${styles.Text}`}>ZuJiKOOPVA</div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${styles.ButtonSec}`}>
                                    <button className={`${styles.Button} ${styles.Blue}`}>Resend Receipt</button>
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                </div>*/}

            </div>
        </div>}
    </>);
}

export default PaymentList;